var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 32,
    viewBox: "0 0 77 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9031 16.5337C76.9031 11.0651 74.2542 6.75 69.1915 6.75C64.1073 6.75 61.0312 11.0651 61.0312 16.491C61.0312 22.9209 64.6628 26.1679 69.875 26.1679C72.4171 26.1679 74.3397 25.5911 75.7923 24.7794V20.507C74.3397 21.2333 72.6734 21.6819 70.5586 21.6819C68.4865 21.6819 66.6494 20.9556 66.4144 18.4349H76.8604C76.8604 18.1572 76.9031 17.0464 76.9031 16.5337ZM66.3503 14.5043C66.3503 12.0905 67.8243 11.0864 69.1701 11.0864C70.4732 11.0864 71.8617 12.0905 71.8617 14.5043H66.3503Z",
    fill: "#635BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7853 6.75C50.6919 6.75 49.3461 7.73264 48.5984 8.41622L48.3207 7.09179H43.6211V31.9997L48.9615 30.8675L48.9829 24.8221C49.7519 25.3775 50.8841 26.1679 52.7639 26.1679C56.5877 26.1679 60.0697 23.0918 60.0697 16.3201C60.0483 10.1252 56.5236 6.75 52.7853 6.75ZM51.5036 21.4683C50.2433 21.4683 49.4956 21.0197 48.9829 20.4643L48.9615 12.5391C49.517 11.9196 50.286 11.4923 51.5036 11.4923C53.4475 11.4923 54.7933 13.6712 54.7933 16.4696C54.7933 19.3321 53.4689 21.4683 51.5036 21.4683Z",
    fill: "#635BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2715 5.48999L41.6333 4.33645V0L36.2715 1.13218V5.48999Z",
    fill: "#635BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6333 7.10938H36.2715V25.801H41.6333V7.10938Z",
    fill: "#635BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5263 8.69221L30.1845 7.11143H25.5703V25.803H30.9108V13.1355C32.1711 11.4906 34.3073 11.7897 34.9695 12.0247V7.11143C34.2859 6.85509 31.7866 6.38513 30.5263 8.69221Z",
    fill: "#635BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.845 2.47656L14.6327 3.58738L14.6113 20.6982C14.6113 23.8597 16.9825 26.1882 20.144 26.1882C21.8957 26.1882 23.1774 25.8678 23.8824 25.4832V21.1468C23.1988 21.4245 19.8236 22.4071 19.8236 19.2456V11.6621H23.8824V7.11208H19.8236L19.845 2.47656Z",
    fill: "#635BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40454 12.5391C5.40454 11.7059 6.08812 11.3855 7.22029 11.3855C8.84379 11.3855 10.8945 11.8768 12.518 12.7527V7.73264C10.745 7.0277 8.99332 6.75 7.22029 6.75C2.88385 6.75 0 9.01435 0 12.7954C0 18.6913 8.11749 17.7513 8.11749 20.2934C8.11749 21.276 7.26302 21.5965 6.06676 21.5965C4.29373 21.5965 2.02937 20.8702 0.23498 19.8875V24.9716C2.22163 25.8261 4.22964 26.1893 6.06676 26.1893C10.51 26.1893 13.5648 23.989 13.5648 20.1652C13.5434 13.7994 5.40454 14.9316 5.40454 12.5391Z",
    fill: "#635BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.489053b528085390efa841ad7e1d390b.svg";
export { ForwardRef as ReactComponent };